'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStarOutline = function TiStarOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.1 34.9c-0.4 0-0.7 0-1.1-0.2 0 0-0.1-0.1-0.2-0.1l-6.8-3.9-6.8 3.9c-0.1 0-0.2 0.1-0.2 0.1-0.8 0.4-1.8 0.3-2.6-0.2-0.7-0.6-1.1-1.6-0.9-2.5l1.6-7.8-2.7-2.4-3.2-2.9c0 0-0.1-0.1-0.1-0.1-0.6-0.7-0.8-1.6-0.6-2.5 0.3-0.9 1.1-1.5 2-1.7 0 0 0.1 0 0.1 0l7.9-0.9 3.2-7.2c0 0 0.1-0.1 0.1-0.2 0.5-0.7 1.3-1.2 2.2-1.2 0.9 0 1.7 0.5 2.2 1.2 0 0.1 0 0.2 0.1 0.2l3.2 7.2 7.9 0.9c0 0 0.1 0 0.1 0 0.9 0.2 1.7 0.8 2 1.7 0.2 0.9 0 1.8-0.6 2.5 0 0-0.1 0.1-0.1 0.1l-5.9 5.3 1.6 7.7c0.2 1-0.2 2-0.9 2.6-0.5 0.3-1 0.4-1.5 0.4z m-13.6-10.9c-0.1 0.3-0.8 3.7-1.4 6.8l6.1-3.5c0.5-0.2 1.1-0.2 1.6 0l6.1 3.5-1.4-6.8c-0.1-0.6 0.1-1.2 0.5-1.6l5.2-4.7-7-0.8c-0.6 0-1.1-0.4-1.3-1l-2.9-6.3-2.9 6.3c-0.2 0.6-0.7 1-1.3 1l-7 0.8 5.2 4.7c0.5 0.4 0.6 1 0.5 1.6z' })
        )
    );
};

exports.default = TiStarOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/star-outline.js
// module id = 3983
// module chunks = 0